var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-filter-buttons"},[_c('SrButton',{attrs:{"color":"primary","text":""},on:{"click":_vm.resetFilters}},[_vm._v(" Reset Filters ")]),_c('SrButton',{attrs:{"color":"primary","text":""},on:{"click":_vm.apply}},[_vm._v(" Apply Filters ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }